// todo: minPx and maxPix is used in picture component
export const minPx = {
  xlarge: 1440,
  large: 1024,
  medium: 768
}

export const maxPx = {
  large: 1439,
  medium: 1023,
  small: 767
}

export const min = (breakpoints) => ({
  xlarge: `(min-width: ${breakpoints.xlarge.width}px)`,
  large: `(min-width: ${breakpoints.large.width}px)`,
  medium: `(min-width: ${breakpoints.medium.width}px)`
})

export const max = (breakpoints) => ({
  large: `(max-width: ${breakpoints.xlarge.width - 1}px)`,
  medium: `(max-width: ${breakpoints.large.width - 1}px)`,
  small: `(max-width: ${breakpoints.medium.width - 1}px)`
})

export default {
  min,
  max,
  minPx,
  maxPx
}
